import { render, staticRenderFns } from "./Pack.vue?vue&type=template&id=705678a2&scoped=true&"
import script from "./Pack.vue?vue&type=script&lang=ts&"
export * from "./Pack.vue?vue&type=script&lang=ts&"
import style0 from "./Pack.vue?vue&type=style&index=0&id=705678a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705678a2",
  null
  
)

export default component.exports